import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { SimplePage } from 'common';
import { fetchPrivacyPolicy } from './PrivacyPolicySlice';
import { PrivacyPolicyContentSelector } from './PrivacyPolicyContentSelector';

export function usePrivacyPolicy(): AbstractContentState<SimplePage> {
    return useCmsContent(fetchPrivacyPolicy, PrivacyPolicyContentSelector);
}
